import { useBrand } from '../lib/brand';
import { MarketingShell, Pill, usePageMeta } from './chrome';
import { founderStory } from './content';
import { WaterTexture } from './frames';

export default function StoryPage() {
  const brand = useBrand();
  usePageMeta(`Story · ${brand.name}`, founderStory.title);
  return (
    <MarketingShell>
      <article>
        <header className="mkt-band mkt-band-story" data-mkt-surface="dark">
          <WaterTexture />
          <div className="relative z-[1] mx-auto max-w-copy px-6 py-mkt-sm md:py-mkt">
            <h1 className="max-w-[14ch] text-balance text-mkt-section-sm text-white md:text-mkt-section">{founderStory.title}</h1>
            <p className="mt-6 text-[21px] font-medium text-white">{founderStory.byline}</p>
          </div>
        </header>
        <div className="mx-auto max-w-copy space-y-5 px-6 py-mkt-sm text-mkt-body text-mkt-ink md:py-mkt">
          {founderStory.paragraphs.map((paragraph) => (
            <p key={paragraph}>{paragraph}</p>
          ))}
          <div className="pt-6">
            <Pill to="/contact">Book a demo</Pill>
          </div>
        </div>
      </article>
    </MarketingShell>
  );
}
